// extracted by mini-css-extract-plugin
module.exports = {"root":"GithubRepoNotFound_root__6i6Xj"};